export function normalizeAccountId(value: number | string | string[] | null | undefined): number | null {
  const rawValue = Array.isArray(value) ? value[0] : value

  if (rawValue == null || rawValue === "") return null

  const parsedValue = typeof rawValue === "number" ? rawValue : Number(rawValue)

  if (!Number.isInteger(parsedValue) || parsedValue <= 0) {
    return null
  }

  return parsedValue
}

export function normalizeAccountHash(value: string | string[] | null | undefined): string | null {
  const rawValue = Array.isArray(value) ? value[0] : value

  if (!rawValue) {
    return null
  }

  const trimmedValue = rawValue.trim()

  return /^[a-fA-F0-9]{64}$/.test(trimmedValue) ? trimmedValue : null
}

export function buildSubscribeHref(accountHash?: string | null): string {
  const normalizedAccountHash = normalizeAccountHash(accountHash)

  if (!normalizedAccountHash) {
    return "/subscribe"
  }

  return `/subscribe?accountHash=${normalizedAccountHash}`
}

export function buildSubscribeTeamRedirectPath(searchParams: Record<string, string | string[] | undefined>): string {
  const params = new URLSearchParams()

  for (const [key, value] of Object.entries(searchParams)) {
    if (Array.isArray(value)) {
      for (const item of value) {
        params.append(key, item)
      }
      continue
    }

    if (value != null) {
      params.set(key, value)
    }
  }

  const queryString = params.toString()

  return queryString ? `/subscribe/team?${queryString}` : "/subscribe/team"
}

export function isPublicSubscribePath(pathname: string): boolean {
  return pathname === "/subscribe" || pathname === "/subscribe/team" || pathname.startsWith("/subscribe/team/")
}
